import { client } from "../libs/client";

export const verifyTransaction = async (reference, planId) => {
  return await client.post(`/transaction/verify`, { reference, planId });
};

export const getPaymentStatus = async () => {
  return await client.get("/transaction/payment-status");
};

export const initializePayment = async (data) => {
  return await client.post("/transaction/initialize", data);
};
